import OnboardingFirmes from './OnboardingFirmes';
import OnboardingFirmesPoc from './OnboardingFirmesPoC';
import OnboardingBase from './OnboardingBase';
import { useRouter } from 'next/router';

const parseDate = (dateString) => {
    if (!dateString) return null;

    const parsedDate = new Date(dateString.replace(' ', 'T'));
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export default function Component(props) {

    const { layout, items } = props;
    const router = useRouter();
    const esOnboardingActiu = (item) => {
        if (!item.actiu) return false;

        const dataActual = new Date();

        const dataInici = parseDate(item.dataPublicacio);
        const dataFi = parseDate(item.dataDespublicacio);

        const estaActiu = (!dataInici || dataActual >= dataInici) && (!dataFi || dataActual <= dataFi);

        return estaActiu;
    };
    if (!items) return null;
    const onboardingsActius = items.filter(esOnboardingActiu);
    
    if (onboardingsActius.length === 0) return null;

    return (
        <>
            {onboardingsActius.map((onboardingActiu) => {
                // Comprovació: si és OnboardingFirmesPoC, només renderitzar si URL conté "firmes-poc"

                switch (onboardingActiu.tipus) {
                    case 'component':
                        return <OnboardingBase key={onboardingActiu.id} onboardingActiu={onboardingActiu} layout={layout} />;
                    case 'custom':
                        return <OnboardingBase key={onboardingActiu.id} onboardingActiu={onboardingActiu} layout={layout} />;
                    case 'OnboardingFirmes':
                        return !router.asPath.includes('firmes-poc') && <OnboardingFirmes key={onboardingActiu.id} {...props} onboardingActiu={onboardingActiu} layout={layout} />;
                    case 'OnboardingFirmesPoC':
                        return router.asPath.includes('firmes-poc') && <OnboardingFirmesPoc key={onboardingActiu.id} {...props} onboardingActiu={onboardingActiu} layout={layout} />;
                    default:
                        return null;
                }
            })}
        </>
    );
}
